import { render } from "./PaymentReceipt.vue?vue&type=template&id=a5f9d60e&scoped=true"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js"

import "./PaymentReceipt.vue?vue&type=style&index=0&id=a5f9d60e&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f9d60e"]])

export default __exports__